import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import {
  setUnverifiedEmail,
  setIsAlmostDone,
  setIsUserNotConfirmed,
  setShowSignupModal,
  setShowLoginModal,
} from '../../slices/accounts';
import messages from './messages';
import styles from './SignupModal.module.scss';
import FlyoutModal from '../common/FlyoutModal';
import SignupForm from '../forms/SignupForm/SignupForm';
import LinkButton from '../common/LinkButton';

const SignupModal = ({
  isVisible,
}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const openLoginModal = () => {
    dispatch(setShowLoginModal({ showLoginModal: true }));
    dispatch(setShowSignupModal({ showSignupModal: false }));
  };
  const closeModal = () => {
    dispatch(setShowLoginModal({ showLoginModal: false }));
    dispatch(setShowSignupModal({ showSignupModal: false }));
    dispatch(setIsAlmostDone({ isAlmostDone: false }));
    dispatch(setIsUserNotConfirmed({ isUserNotConfirmed: false }));
    dispatch(setUnverifiedEmail({ unverifiedEmail: '' }));
  };

  const accountCreated = (email) => {
    dispatch(setUnverifiedEmail({ unverifiedEmail: email }));
    dispatch(setIsAlmostDone({ isAlmostDone: true }));
    openLoginModal();
  };

  return (
    <FlyoutModal
      isVisible={isVisible}
      backButtonLabel={formatMessage(messages.backBtn)}
      onCloseModal={closeModal}
    >
      <>
        <h4 className={styles.modalHeader}>{formatMessage(messages.header)}</h4>
        <SignupForm
          onCreationSuccessCallback={accountCreated}
          openLoginModalCallback={openLoginModal}
        />
        <p className={styles.loginInsteadLink}>
          <span className={styles.loginInsteadMsg}>
            {formatMessage(messages.footerMain)}
          </span>
          <LinkButton
            id="signInLink"
            onClick={openLoginModal}
            linkText={formatMessage(messages.footerLink)}
          />
        </p>
      </>
    </FlyoutModal>
  );
};

SignupModal.propTypes = {
  isVisible: PropTypes.bool,
};
SignupModal.defaultProps = {
  isVisible: true,
};

export default SignupModal;
